import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

const STORAGE_KEY = 'abovelms.learner.theme';
const DARK_CLASS = 'dark-mode';

type Theme = 'light' | 'dark';

function getInitialTheme(): Theme {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'dark' || stored === 'light') return stored;
  return 'light';
}

function applyTheme(theme: Theme): void {
  document.documentElement.classList.toggle(DARK_CLASS, theme === 'dark');
}

export const useThemeStore = defineStore('theme', () => {
  const theme = ref<Theme>(getInitialTheme());
  applyTheme(theme.value);

  watch(theme, (value) => {
    applyTheme(value);
    localStorage.setItem(STORAGE_KEY, value);
  });

  function toggle(): void {
    theme.value = theme.value === 'dark' ? 'light' : 'dark';
  }

  return { theme, toggle };
});
